import { useI18n } from '@/i18n'
import { Badge } from '@/ui'
import type { DeclarationInfo } from '../projection'

/** Bay declaration state: declared clean (with days left), not clean, expired, old form, none. */
export function DeclarationBadge({ info }: { info: DeclarationInfo }) {
  const { t } = useI18n()
  switch (info.status) {
    case 'CLEAN':
      return (
        <Badge tone={info.renewSoon ? 'warn' : 'ok'}>
          {info.renewSoon
            ? t('store.decl.renewSoon', { days: info.daysLeft ?? 0 })
            : t('store.decl.clean')}
        </Badge>
      )
    case 'NOT_CLEAN':
      return <Badge tone="danger">{t('store.decl.notClean')}</Badge>
    case 'EXPIRED':
      return <Badge tone="danger">{t('store.decl.expired')}</Badge>
    case 'OLD_FORM':
      return <Badge tone="warn">{t('store.decl.oldForm')}</Badge>
    default:
      return <Badge>{t('store.decl.none')}</Badge>
  }
}
